(function () {
    "use strict";

    // @ngInject
    function AccountsServiceCtor(AccountsManager, AppStates, $state, PubSubService, Enums, UsersManager, SplashScreenService) {
        this.AccountsManager = AccountsManager;
        this.AppStates = AppStates;
        this.$state = $state;
        this.Enums = Enums;
        this.UsersManager = UsersManager;
        this.SplashScreenService = SplashScreenService;

        PubSubService.ventMyBitchUp(this);
    }

    Services.AccountsService = Class(() => {

        return {
            constructor: AccountsServiceCtor,

            createCompany(accountId, companyType, companyName) {
                this.SplashScreenService.showHB();
                return this.AccountsManager.createCompany(accountId, companyType, companyName);
            },

            switchCompany(companyId, keepState) {
                return this.SplashScreenService.showHB().then(() => {
                    return this.AccountsManager.switchCompany(companyId);
                }).then(() => {
                    this.trigger(this.Enums.PubSubTriggers.companyChanged);
                    this.SplashScreenService.hideHB();
                    if (!keepState) {
                        this.$state.go(this.AppStates.root_core_navigation_home);
                    }
                });
            }
        };
    });
}());

